import {
  DevHubBox,
  DevHubGrid,
  DevHubTypography,
} from '@devxdiscover/devhub-ui';
import { useCGAHierarchyStyles } from '../styles';

interface SummaryStatisticsCardsProps {
  totalCount: number;
  activeCount: number;
  preProdCount: number;
  selectedCount: number;
}

/**
 * Summary statistics cards component displaying application counts.
 * Shows total applications, active, pre-prod, and selected counts in a card layout.
 * @param props - Component props
 * @param props.totalCount - Total number of applications
 * @param props.activeCount - Number of active applications
 * @param props.preProdCount - Number of pre-prod applications
 * @param props.selectedCount - Number of selected applications
 * @returns SummaryStatisticsCards component
 */
export const SummaryStatisticsCards = ({
  totalCount,
  activeCount,
  preProdCount,
  selectedCount,
}: SummaryStatisticsCardsProps) => {
  const classes = useCGAHierarchyStyles();

  return (
    <DevHubBox className={classes.summaryCardsContainer}>
      <DevHubGrid container spacing={2}>
        <DevHubGrid item xs={6} sm={3} md={2}>
          <DevHubBox className={classes.summaryCard}>
            <DevHubTypography
              className={classes.summaryCardValue}
              style={{ color: '#1976d2' }}
            >
              {totalCount}
            </DevHubTypography>
            <DevHubTypography className={classes.summaryCardLabel}>
              Total Applications
            </DevHubTypography>
          </DevHubBox>
        </DevHubGrid>
        <DevHubGrid item xs={6} sm={3} md={2}>
          <DevHubBox className={classes.summaryCard}>
            <DevHubTypography
              className={classes.summaryCardValue}
              style={{ color: '#2e7d32' }}
            >
              {activeCount}
            </DevHubTypography>
            <DevHubTypography className={classes.summaryCardLabel}>
              Active
            </DevHubTypography>
          </DevHubBox>
        </DevHubGrid>
        <DevHubGrid item xs={6} sm={3} md={2}>
          <DevHubBox className={classes.summaryCard}>
            <DevHubTypography
              className={classes.summaryCardValue}
              style={{ color: '#1565c0' }}
            >
              {preProdCount}
            </DevHubTypography>
            <DevHubTypography className={classes.summaryCardLabel}>
              Pre-Prod
            </DevHubTypography>
          </DevHubBox>
        </DevHubGrid>
        <DevHubGrid item xs={6} sm={3} md={2}>
          <DevHubBox className={classes.summaryCard}>
            <DevHubTypography
              className={classes.summaryCardValue}
              style={{ color: '#7b1fa2' }}
            >
              {selectedCount}
            </DevHubTypography>
            <DevHubTypography className={classes.summaryCardLabel}>
              Selected
            </DevHubTypography>
          </DevHubBox>
        </DevHubGrid>
      </DevHubGrid>
    </DevHubBox>
  );
};
